import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import CurrencyConverter from '../../CurrencyConverter';

// Locale
import messages from '../../../locale/jsonMessages';

import s from '../ViewMessage.css';

const CancelDetails = (props) => {

	const { userType, reservationData, openModal, checkOutDifference } = props;
	const { cancelData: { refundToGuest, payoutToHost, currency } } = props;
	const { reservationData: { total, hostServiceFee } } = props;
	let earnedAmount = 0, missedEarnings = 0, refund = 0, estimatedEarning = 0;
	let claimAmount = 0, claimStatus = 0, securityDeposit = 0, claimPayout = 0;

	earnedAmount = payoutToHost;
	refund = refundToGuest;
	missedEarnings = (total - hostServiceFee) - earnedAmount;
	estimatedEarning = total - hostServiceFee;

	if (reservationData) {
		claimStatus = reservationData.claimStatus;
		securityDeposit = reservationData.securityDeposit
		claimAmount = reservationData.claimAmount;
		claimPayout = reservationData.claimPayout;
	}

	return (
		<div className={cx(s.cancelDetailsContainer)}>
			{((userType === 'owner' && (estimatedEarning > 0 || earnedAmount > 0 || missedEarnings > 0 || securityDeposit > 0 || claimPayout > 0)) || (userType === 'renter' && refund > 0)) && <>
				<div>
					<hr className={s.billingLine} />
					<h4 className={cx(s.space3, s.marginTop0, s.tripDetails)}>
						<span><FormattedMessage {...messages.billing} /></span>
					</h4>
				</div>

				{
					userType === 'owner' && estimatedEarning > 0 && <div className={cx(s.cancelDetailsItems)}>
						<hr className={s.billingLine} />
						<div className={cx(s.checkInText, s.billingTextContainer)}>
							<div className={cx(s.textLeft, s.lsBillingText, 'textAlignRightRTL')}>
								<span><FormattedMessage {...messages.estimatedEarnings} /></span>
							</div>
							<div className={cx(s.textRight, s.rsBillingText, 'textAlignLeftRTL')}>
								<span>
									<CurrencyConverter
										amount={estimatedEarning > 0 ? estimatedEarning : 0}
										from={currency}
									/>
								</span>
							</div>
						</div>
					</div>
				}

				{
					userType === 'owner' && earnedAmount > 0 && <div className={cx(s.cancelDetailsItems)}>
						<hr className={s.billingLine} />
						<div className={cx(s.checkInText, s.billingTextContainer)}>
							<div className={cx(s.textLeft, s.lsBillingText, 'textAlignRightRTL')}>
								<span><FormattedMessage {...messages.earnedAmount} /></span>
							</div>
							<div className={cx(s.textRight, s.rsBillingText, 'textAlignLeftRTL')}>
								<span>
									<CurrencyConverter
										amount={earnedAmount}
										from={currency}
									/>
								</span>
							</div>
						</div>
					</div>
				}

				{
					userType === 'owner' && missedEarnings > 0 && <div className={cx(s.cancelDetailsItems)}>
						<hr className={s.billingLine} />
						<div className={cx(s.checkInText, s.billingTextContainer)}>
							<div className={cx(s.textLeft, s.lsBillingText, 'textAlignRightRTL')}>
								<span><FormattedMessage {...messages.missedEarnings} /></span>
							</div>
							<div className={cx(s.textRight, s.rsBillingText, 'textAlignLeftRTL')}>
								<span>
									<CurrencyConverter
										amount={missedEarnings}
										from={currency}
									/>
								</span>
							</div>
						</div>
					</div>
				}

				{
					userType === 'renter' && refund > 0 && <div className={cx(s.cancelDetailsItems)}>
						<hr className={s.billingLine} />
						<div className={cx(s.checkInText, s.billingTextContainer)}>
							<div className={cx(s.textLeft, s.lsBillingText, 'textAlignRightRTL')}>
								<span><FormattedMessage {...messages.refundAmount} /></span>
							</div>
							<div className={cx(s.textRight, s.rsBillingText, 'textAlignLeftRTL')}>
								<span>
									<CurrencyConverter
										amount={refund}
										from={currency}
									/>
								</span>
							</div>
						</div>
					</div>
				}
				{
					userType === 'owner' && securityDeposit > 0 && <div className={cx(s.cancelDetailsItems)}>
						<hr className={s.billingLine} />
						<div className={cx(s.checkInDt, s.billingTextContainer)}>
							<div className={cx(s.textLeft, s.lsBillingText, 'textAlignRightRTL')}>
								<span><FormattedMessage {...messages.securityDepositByRenter} /></span>
								{securityDeposit > 0 && claimStatus == 'pending' && checkOutDifference > 0 && checkOutDifference < 24 && <a className={s.link} onClick={() => openModal()}>{' ('}<FormattedMessage {...messages.claimDamage} />{')'}</a>}
								{securityDeposit > 0 && claimAmount > 0 && <div className={s.spaceTop1}><a className={s.link} onClick={() => openModal()}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a></div>}
							</div>
							<div className={cx(s.textRight, s.rsBillingText, 'textAlignLeftRTL')}>
								<span>
									<CurrencyConverter
										amount={securityDeposit}
										from={reservationData && reservationData.currency}
									/>
								</span>
							</div>
						</div>
					</div>
				}
				{
					userType === 'owner' && claimStatus === 'approved' && claimPayout > 0 && <div className={cx(s.cancelDetailsItems)}>
						<hr className={s.billingLine} />
						<div className={cx(s.checkInDt, s.billingTextContainer)}>
							<div className={cx(s.textLeft, s.lsBillingText, 'textAlignRightRTL')}>
								<span><FormattedMessage {...messages.securityDepositAmountToHost} /></span>
							</div>
							<div className={cx(s.textRight, s.rsBillingText, 'textAlignLeftRTL')}>
								<span>
									<CurrencyConverter
										amount={claimPayout}
										from={reservationData && reservationData.currency}
									/>
								</span>
							</div>
						</div>
					</div>
				}
			</>}

		</div>
	);
}

CancelDetails.propTypes = {
	userType: PropTypes.string.isRequired,
	formatMessage: PropTypes.any,
	cancelData: PropTypes.shape({
		hostServiceFee: PropTypes.number,
		refundToGuest: PropTypes.number,
		payoutToHost: PropTypes.number,
		total: PropTypes.number,
		currency: PropTypes.string,
	})
};

export default withStyles(s)(CancelDetails);

